import MembershipDetail from './MembershipDetail';
export default MembershipDetail;



// WEBPACK FOOTER //
// ./src/pages/MembershipsPage/components/MembershipDetail/components/MembershipDetail/index.ts